<template>
  <div class="timeline-panel">
    <div class="title">患者疗效跟踪反馈</div>
    <a-tabs v-model:activeKey="activeTab" class="timeline-tabs">
      <a-tab-pane key="selfReport">
        <template #tab>
          <span class="tab-label" :class="{ 'is-new': selfReportNew }">患者自述反馈</span>
        </template>
        <SelfReportPanel :self-reported-feedbacks="selfReportedFeedbacks" />
      </a-tab-pane>
      <a-tab-pane key="systemTrace" tab="系统跟踪">
        <SystemTracePanel :ucDoctorId="ucDoctorId" :ucPatientId="ucPatientId" />
      </a-tab-pane>
    </a-tabs>
  </div>
</template>

<script setup>
import { defineProps, ref } from 'vue'
import SelfReportPanel from './TimelinePanel/SelfReportPanel.vue'
import SystemTracePanel from './TimelinePanel/SystemTracePanel.vue'

defineProps({
  ucDoctorId: {
    type: [String, Number],
    default: ''
  },
  ucPatientId: {
    type: [String, Number],
    default: ''
  },
  selfReportedFeedbacks: {
    type: Array,
    default: () => []
  },
  selfReportNew: {
    type: Boolean,
    default: false
  }
})

const activeTab = ref('selfReport')
</script>

<style lang="scss" scoped>
.timeline-panel {
  display: flex;
  flex-direction: column;
  background: #ffffff;
  border-radius: 4px;
  padding: 14px;
  flex: 1;
  min-height: 0;
  overflow: hidden;

  .title {
    color: #333333;
    font-size: 16px;
    font-weight: 500;
    line-height: 22px;
    margin-bottom: 12px;
  }
}

.timeline-tabs {
  display: flex;
  flex-direction: column;
  flex: 1;
  min-height: 0;

  :deep(.ant-tabs-tab) .tab-label.is-new {
    position: relative;

    &::after {
      content: '';
      position: absolute;
      top: 0;
      left: 100%;
      width: 5px;
      height: 5px;
      border-radius: 50%;
      background: #ff2b2b;
    }
  }

  // tab 栏与内容区间距（按 UI 稿）+ 底部分隔线
  :deep(.ant-tabs-bar) {
    margin: 0 0 10px;
    border-bottom: 1px solid #f4f4f4;
  }

  // tab 间距 24px、未选中态文案（按 UI 稿）
  :deep(.ant-tabs-nav .ant-tabs-tab) {
    margin: 0 24px 0 0;
    color: #333333;
    font-size: 16px;
    line-height: 22px;
    padding-left: 0;
    padding-right: 0;
  }

  :deep(.ant-tabs-ink-bar) {
    background: transparent;

    &::after {
      content: '';
      position: absolute;
      bottom: 0;
      left: 15%; // (100% - 70%) / 2，相对激活 tab 居中
      width: 70%; // 相对 ink-bar 本体（= 激活 tab）宽度
      height: 3px;
      background: #1890ff;
    }
  }

  // 面板撑满剩余高度，滚动交给面板内部处理
  :deep(.ant-tabs-content) {
    flex: 1;
    min-height: 0;
  }

  :deep(.ant-tabs-tabpane) {
    height: 100%;
    display: flex;
    flex-direction: column;
  }
}
</style>
